<app-card
	cardTitle
	cardClass="card-datatable"
	[options]="false">
	<form
		(ngSubmit)="search()"
		class="filterform">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group d-flex flex-row">
					<input
						type="text"
						class="form-control d-inline"
						name="keyword"
						placeholder="Cerca..."
						[(ngModel)]="searchparams.genericSearchTerm">
					<button
						type="button"
						class="btn btn-link ml-2"
						(click)="toggleAdvanced()">
						<i class="feather icon-filter"></i>

					</button>
				</div>
			</div>

		</div>
		<div [ngbCollapse]="!showAdvancedSearch">
			<div class="row">
				<!-- entity -->
				<div class="form-grpup col-md-4">
					<label>{{'labels.entity' | translate}}*</label>
					<select
						#entity="ngModel"
						class="form-control custom-select"
						[(ngModel)]="searchparams.simpleTmp['entity']"
						name="entity">

						<option
							*ngFor="let entity of docTemplateTypes"
							[value]="entity.value">
							{{'types.doctemplate-types.'+ entity.value | translate}}
						</option>
					</select>

				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.name' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="name"
							[(ngModel)]="searchparams.likeTmp['name']">
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{'labels.slug' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="slug"
							[(ngModel)]="searchparams.likeTmp['slug']">
					</div>
				</div>

			</div>

		</div>
		<div class="row mt-1">
			<div class="col">
				<button
					type="submit"
					class="btn btn-primary">
					{{'labels.search' | translate}}
				</button>
				<a
					(click)="resetSearch()"
					class="btn btn-default">
					{{'labels.reset' | translate}}
				</a>
			</div>

		</div>
	</form>
</app-card>
